var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPintura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_008-painting-roller",
    "data-name": "008-painting-roller",
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.697,
    height: 98.033,
    viewBox: "0 0 95.697 98.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_274",
    "data-name": "Trazado 274",
    d: "M99.883,16.584H95.745a7.18,7.18,0,0,0-6.877-5.252V6.874A6.881,6.881,0,0,0,81.995,0H20.111a6.881,6.881,0,0,0-6.874,6.874v4.458a7.167,7.167,0,0,0,0,14.333V28.61a6.881,6.881,0,0,0,6.873,6.874H34.176a6.523,6.523,0,0,0,7,.732,6.534,6.534,0,0,0,12.771-.731h6.092a1.915,1.915,0,0,0,0-3.829h-6.02V3.829H81.995a3.048,3.048,0,0,1,3.044,3.044V28.61a3.048,3.048,0,0,1-3.044,3.044H76.763a1.915,1.915,0,0,0,0,3.829h5.232a6.881,6.881,0,0,0,6.873-6.874V25.665a7.179,7.179,0,0,0,6.877-5.252h2.223V36.77A5.174,5.174,0,0,1,92.8,41.938H50.9a1.915,1.915,0,0,0-1.915,1.915v9.733h-2.5a1.915,1.915,0,0,0-1.829,1.349l-3.124,10.1a1.9,1.9,0,0,0-.085.39v.006c0,.007,0,.014,0,.02s0,.024,0,.035V65.5c0,.014,0,.028,0,.042h0c0,.038,0,.076,0,.114V88.571a9.461,9.461,0,1,0,18.922,0V65.653c0-.038,0-.076,0-.114h0c0-.014,0-.029,0-.043v-.009c0-.012,0-.024,0-.035s0-.014,0-.02v-.006a1.9,1.9,0,0,0-.085-.39l-3.124-10.1a1.915,1.915,0,0,0-1.829-1.349h-2.5V45.768H92.8a9.008,9.008,0,0,0,9-9V18.5a1.915,1.915,0,0,0-1.915-1.915ZM9.93,18.5a3.341,3.341,0,0,1,3.307-3.337v6.674A3.341,3.341,0,0,1,9.93,18.5ZM17.067,28.61v-.651a6.531,6.531,0,0,0,8.452-2.844,6.525,6.525,0,0,0,6.193.426v4.834a6.55,6.55,0,0,0,.126,1.279H20.111a3.047,3.047,0,0,1-3.044-3.044Zm33.121,5.906a2.7,2.7,0,1,1-5.408,0V21.294a1.915,1.915,0,1,0-3.829,0v9.081a2.7,2.7,0,1,1-5.408,0V19.593a1.915,1.915,0,0,0-3.829,0,2.7,2.7,0,1,1-5.408,0,1.915,1.915,0,1,0-3.829,0v2.418a2.7,2.7,0,1,1-5.408,0V6.874a3.048,3.048,0,0,1,3.044-3.044H50.187ZM88.868,21.835V15.161a3.337,3.337,0,0,1,0,6.674ZM56.534,88.571a5.632,5.632,0,1,1-11.263,0V67.552H56.534Zm-.681-24.849h-9.9L47.9,57.415h6Z",
    transform: "translate(-6.101 0)",
    fill: "#003082"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_157",
    "data-name": "Grupo 157",
    transform: "translate(60.528 31.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156",
    "data-name": "Grupo 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_275",
    "data-name": "Trazado 275",
    d: "M324.135,169.195a1.914,1.914,0,1,1,1.767-2.646A1.924,1.924,0,0,1,324.135,169.195Z",
    transform: "translate(-322.221 -165.376)",
    fill: "#86888b"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159",
    transform: "translate(42.887 82.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_276",
    "data-name": "Trazado 276",
    d: "M232,438.846a1.915,1.915,0,0,1-1.915-1.915V433.3a1.915,1.915,0,1,1,3.829,0v3.632A1.915,1.915,0,0,1,232,438.846Z",
    transform: "translate(-230.087 -431.385)",
    fill: "#86888b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintura);
export default __webpack_public_path__ + "static/media/pintura.4a9fb2071a08d5a637d650cf9a67d247.svg";
export { ForwardRef as ReactComponent };